import { render, staticRenderFns } from "./MedicineDelete.vue?vue&type=template&id=294adac4&scoped=true&"
import script from "./MedicineDelete.vue?vue&type=script&lang=js&"
export * from "./MedicineDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294adac4",
  null
  
)

export default component.exports